import { CellulaLanguage } from '../components/i18n_provider';

export function getCellulaLanguage(lang: string): CellulaLanguage {
	switch (lang) {
		case 'da':
			return 'da';
		case 'de':
			return 'de';
		case 'en':
			return 'en';
		case 'fi':
			return 'fi';
		case 'nl':
			return 'nl';
		case 'no':
		case 'nb':
			return 'no';
		case 'sv':
			return 'sv';
		default:
			return 'en';
	}
}
